module.exports = __webpack_public_path__ + "img/subscriptions.cfee6f82.svg";